export enum CameraLayers {
  HORIZONTAL_RESIZE = 7,
  VERTICAL_RESIZE = 8,
  SPRITE_2D = 9
}



// WEBPACK FOOTER //
// ./src/app/enum/CameraLayers.ts